import { Badge } from 'antd';
import { Link } from 'react-router-dom';

import { TEntityGridColumn } from 'app/common/entity-grid/core';
import {
  RangeDateFilterDataGrid,
  StringFilterDataGrid,
} from 'app/common/ui/data-grid/filters';
import { TTrip } from 'app/railways/domains/trips/core/trips';
import { appRoute } from 'app/railways/router/routes';

import { EOrderStatus, TTicketOrder } from '../../core/tickets-order';

export const cols: TEntityGridColumn<TTicketOrder>[] = [
  {
    field: 'id',
    // type: 'rightAligned',
    headerName: 'ID',
    minWidth: 50,
    headerCheckboxSelection: true,
    checkboxSelection: true,
    sortable: true,
    comparator: () => 0,
    cellRenderer: ({ value }: { value: number }) => {
      const path = appRoute.TICKETS.ORDER.buildPath({
        id: value,
      });

      return <Link to={path}>{value}</Link>;
    },
    filter: StringFilterDataGrid({
      filterName: 'id',
      placeholder: 'Введите ID заказа',
    }),
  },
  {
    field: 'status',
    headerName: 'Статус',
    sortable: true,
    comparator: () => 0,
    cellRenderer: ({ value }: { value: EOrderStatus }) => {
      switch (value) {
        case EOrderStatus.created:
          return (
            <Badge
              status="processing"
              text="Создан"
              style={{ whiteSpace: 'nowrap' }}
            />
          );
        case EOrderStatus.ok:
          return (
            <Badge
              status="success"
              text="Выполнен"
              style={{ whiteSpace: 'nowrap' }}
            />
          );
        case EOrderStatus.error:
          return (
            <Badge
              status="error"
              text="Ошибка"
              style={{ whiteSpace: 'nowrap' }}
            />
          );
        case EOrderStatus.booked:
          return (
            <Badge
              status="warning"
              text="Забронирован"
              style={{ whiteSpace: 'nowrap' }}
            />
          );
        case EOrderStatus.canceled:
          return (
            <Badge
              status="default"
              text="Отменен"
              style={{ whiteSpace: 'nowrap' }}
            />
          );
      }
    },
  },
  {
    field: 'description',
    headerName: 'Описание статуса',
    sortable: false,
    colId: 'description',
    comparator: () => 0,
  },
  {
    field: 'personId',
    headerName: 'Пассажир',
    sortable: false,
    colId: 'personId',
    comparator: () => 0,
    cellRenderer: ({ value }: { value: number }) => {
      const path = appRoute.PERSON.DETAILS.buildPath({
        passengerId: value,
      });

      return <Link to={path}>Открыть</Link>;
    },
  },
  {
    field: 'date',
    headerName: 'Дата заказа',
    sortable: true,
    colId: 'date',
    comparator: () => 0,
    cellRenderer: ({ value }: { value: string }) => {
      const date = new Date(value).toLocaleString();

      return date;
    },
    // @ts-expect-error ...
    filter: RangeDateFilterDataGrid({
      filterName: 'date',
    }),
  },
  {
    field: 'stationFromId',
    headerName: 'Станция отправления',
    sortable: true,
    colId: 'stationFromId',
    comparator: () => 0,
    cellRenderer: ({ data }: { data: TTicketOrder }) => {
      const stationFrom = data.tickets[0].stationFrom.nameRu;

      return stationFrom;
    },
  },
  {
    field: 'stationToId',
    headerName: 'Станция Назначения',
    sortable: true,
    colId: 'stationToId',
    comparator: () => 0,
    cellRenderer: ({ data }: { data: TTicketOrder }) => {
      const stationFrom = data.tickets[0].stationTo.nameRu;

      return stationFrom;
    },
  },
  {
    headerName: 'Номер вагона',
    sortable: true,
    colId: 'wagonNum',
    comparator: () => 0,
    cellRenderer: ({ data }: { data: TTicketOrder }) => {
      const ticket = data.tickets.find(
        (ticket) =>
          ticket.mainTicketId == undefined && ticket.wagonNum != undefined,
      );

      return ticket?.wagonNum;
    },
  },
  {
    headerName: 'Номер места',
    sortable: true,
    colId: 'seatNum',
    comparator: () => 0,
    cellRenderer: ({ data }: { data: TTicketOrder }) => {
      const ticket = data.tickets.find(
        (ticket) =>
          ticket.mainTicketId == undefined && ticket.wagonNum != undefined,
      );
      const seatNum = ticket?.seatNum;

      return seatNum;
    },
  },
  {
    headerName: 'Тарифы',
    sortable: true,
    colId: 'ticketItems',
    comparator: () => 0,
    cellRenderer: ({ data }: { data: TTicketOrder }) => {
      const count = data.tickets.length;

      return `${count} шт.`;
    },
  },
  {
    headerName: 'Сумма',
    sortable: true,
    colId: 'ticketItems',
    comparator: () => 0,
    cellRenderer: ({ data }: { data: TTicketOrder }) => {
      const paySumm = data.paySumm;

      return paySumm ? `${paySumm} ֏` : '-';
    },
  },
  {
    colId: 'details',
    // type: 'rightAligned',
    headerName: 'Подробнее',
    // headerCheckboxSelection: true,
    cellRenderer: ({ data }: { data: TTrip }) => {
      const path = appRoute.TICKETS.ORDER.buildPath({
        id: data.id,
      });

      return <Link to={path}>Подробнее</Link>;
    },
  },
];
